/** 設定識別ID */
export const SCREEN_ACTION_SETTING_ID = 'vehicle-search-s-a-setting';

/**
 * 顧客車両検索画面動作設定インターフェース定義
 */
export interface ICustomerVehicleSearchScreenActionSetting {
  /** 顧客ランクによる色分け */
  customerRankColorDiv: string;
}

/**
 * 顧客ランクによる色分けのenum定義
 */
export const CustomerRankColorDiv = {
  /** 反映しない */
  None: '0',
  /** お客様名、フリガナに反映する */
  ReflectInName: '1',
  /** 行すべてに反映する */
  // TODO: 今後実装予定
  // ReflectInAll: '2',
};

/**
 * 顧客ランクによる色分けの配列情報
 */
export const CustomerRankColorDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '反映しない' },
  { value: '1', text: 'お客様名、フリガナ、車両登録番号に反映する' },
  // TODO: 今後実装予定
  // { value: '2', text: '行すべてに反映する' },
];

/**
 * ベースとなる顧客車両検索画面動作設定
 */
export const BaseScreenActionSetting: ICustomerVehicleSearchScreenActionSetting = {
  customerRankColorDiv: CustomerRankColorDiv.None,
};



// WEBPACK FOOTER //
// ./src/app/feature/customer-vehicle-search-screen-action-setting-modal/customer-vehicle-search-screen-action-setting-modal.define.ts